/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';

import AuthLayout from './layouts/Auth';
import ErrorLayout from './layouts/Error';
import DashboardLayout from './layouts/Dashboard';
import Dashboard from './views/@Finsense/Dashboard';
import Transfer from './views/@Finsense/Transfer';
import ImportFile from './views/@Finsense/ImportFile';
import Charge from './views/@Finsense/Charge';
import Billing from './views/@Finsense/Billing';
import RequestHelp from './views/@Finsense/RequestHelp';
import ChangePassword from './views/@Finsense/ChangePassword';

const routes = [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/dashboard" />
  },
  {
    path: '/auth',
    component: AuthLayout,
    routes: [
      {
        path: '/auth/login',
        exact: true,
        component: lazy(() => import('views/@Finsense/Login'))
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    path: '/errors',
    component: ErrorLayout,
    routes: [
      {
        path: '/errors/error-404',
        exact: true,
        component: lazy(() => import('views/Error404'))
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    route: '*',
    component: DashboardLayout,
    routes: [
      {
        path: '/help',
        exact: true,
        component: RequestHelp
      },
      {
        path: '/change-password',
        exact: true,
        component: ChangePassword
      },
      {
        path: '/dashboard',
        exact: true,
        component: Dashboard
      },
      {
        path: '/charge',
        exact: true,
        component: Charge
      },
      {
        path: '/transfer',
        exact: true,
        component: Transfer
      },
      {
        path: '/transfer/import-file',
        exact: true,
        component: ImportFile
      },
      {
        path: '/billing',
        exact: true,
        component: Billing
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  }
];

export default routes;
